import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../api/axiosInstance';

export const fetchDefaultCategories = createAsyncThunk(
    'categories/fetchDefaultCategories',
    async (_, { rejectWithValue }) => {
        try {
            const { data } = await axiosInstance.get(`/categories/list?type=default&status=1`);
            return data;
        } catch (error) {
            return rejectWithValue('Failed to fetch user');
        }
    },
);
export const fetchQurbaniCategories = createAsyncThunk(
    'categories/fetchQurbaniCategories',
    async (_, { rejectWithValue }) => {
        try {
            const { data } = await axiosInstance.get(`/categories/list?category_type=qurbani`);
            return data;
        } catch (error) {
            return rejectWithValue('Failed to fetch user');
        }
    },
);

export const fetchProductSummaryCategories = createAsyncThunk(
    'categories/fetchProductSummaryCategories',
    async (_, { rejectWithValue }) => {
        try {
            const { data } = await axiosInstance.get(
                '/categories/list?category_type=default&status=1&inventory_checks=false&edit_order_item=false&product_info=false',
            );
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || 'Failed to fetch categories');
        }
    },
);

export const updateCategoryStatus = createAsyncThunk(
    'categories/updateCategoryStatus',
    async ({ category_id, status }, { rejectWithValue }) => {
        try {
            const payload = {
                action: 'change-category-status',
                category_id,
                status,
            };
            const { data } = await axiosInstance.post(`/categories/change-status`, payload);
            return { category_id, status, data };
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || 'Failed to update category status');
        }
    },
);